module.exports = __webpack_public_path__ + "static/media/sherbet.3d216d85.png";